(() => {
  const minimumCents = 15000;
  const checkoutSelector = 'button[name="checkout"], input[name="checkout"], a[href*="/checkout"]';
  let refreshTimer;

  const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'USD',
  }).format(cents / 100);

  const setNotice = (cart) => {
    const existing = document.querySelector('[data-fmn-wholesale-minimum]');
    const target = document.querySelector('#main-cart-footer .cart__footer, .cart-drawer__footer, .cart__footer');
    if (!target) return;

    if (cart.total_price >= minimumCents) {
      existing?.remove();
      return;
    }

    const shortfall = minimumCents - cart.total_price;
    const renderNotice = (notice) => {
      const amount = document.createElement('span');
      amount.className = 'fmn-wholesale-minimum__amount';
      amount.textContent = `${formatMoney(shortfall)} more`;
      notice.replaceChildren(
        `Wholesale orders require a minimum of ${formatMoney(minimumCents)}. Add `,
        amount,
        ' to continue to checkout.'
      );
    };
    if (existing) {
      renderNotice(existing);
      return;
    }

    const notice = document.createElement('p');
    notice.dataset.fmnWholesaleMinimum = '';
    notice.className = 'fmn-wholesale-minimum-notice';
    notice.setAttribute('role', 'alert');
    renderNotice(notice);
    target.prepend(notice);
  };

  const refresh = async () => {
    try {
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((response) => response.json());
      const blocked = cart.total_price < minimumCents;
      document.querySelectorAll(checkoutSelector).forEach((button) => {
        button.dataset.fmnMinimumBlocked = blocked ? 'true' : 'false';
        button.setAttribute('aria-disabled', blocked ? 'true' : 'false');
        button.classList.toggle('fmn-checkout-blocked', blocked);
        if (button.matches('button, input')) button.disabled = blocked;
      });
      setNotice(cart);
    } catch (error) {
      console.warn('Unable to check wholesale minimum.', error);
    }
  };

  const scheduleRefresh = () => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, 450);
  };

  document.addEventListener('click', (event) => {
    const checkout = event.target.closest(checkoutSelector);
    if (checkout?.dataset.fmnMinimumBlocked === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      refresh();
      return;
    }
    scheduleRefresh();
  }, true);

  document.addEventListener('change', scheduleRefresh, true);
  const removeLegacyMinimumNotice = () => {
    const messagePattern = /(minimum order is \$350\.|your cart must reach \$350 to checkout|you have to buy at least\s+\$?350(?:\.00)?)/i;
    const textWalker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    const matchingTextNodes = [];
    while (textWalker.nextNode()) {
      if (messagePattern.test(textWalker.currentNode.nodeValue || '')) matchingTextNodes.push(textWalker.currentNode);
    }
    matchingTextNodes.forEach((textNode) => {
      const parent = textNode.parentElement;
      textNode.nodeValue = '';
      if (parent && !parent.textContent.trim()) parent.style.display = 'none';
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    removeLegacyMinimumNotice();
    new MutationObserver(removeLegacyMinimumNotice).observe(document.body, { childList: true, subtree: true });
    refresh();
  });
  window.addEventListener('pageshow', () => {
    removeLegacyMinimumNotice();
    refresh();
  });
})();